import {
  ColumnsType,
  FloatingFormItem,
  InfiniteTable,
  InputDate,
} from '@/components/_common';
import { useCrmCustomerWithoutMovimentList } from '@/core/domain/crm/CrmList/CrmList.hooks';
import { CrmCustomerListResponse } from '@/core/domain/crm/CrmList/CrmList.types';
import { flatInfiniteData } from '@/utils/request/flatInfiniteData';
import {
  Button,
  Checkbox,
  Col,
  Form,
  Modal,
  ModalProps,
  Row,
  Space,
  Tooltip,
} from 'antd';

import moment, { Moment } from 'moment';
import { Eye } from 'react-feather';
import { useHistory } from 'react-router-dom';

interface Props extends ModalProps {
  onCancel: () => void;
  onChange: (checked: boolean) => void;
  show: boolean;
}

export default function NoMovementCustomerModal({
  open,
  onCancel,
  onChange,
  show,
}: Props) {
  const history = useHistory();
  const [form] = Form.useForm<{ initialDate?: Moment; finalDate?: Moment }>();

  const initialDateWatch =
    Form.useWatch('initialDate', form) || moment().subtract(2, 'months');
  const finalDateWatch = Form.useWatch('finalDate', form) || moment();

  const { data, isFetching, isLoading, hasNextPage, fetchNextPage } =
    useCrmCustomerWithoutMovimentList({
      initialDate: initialDateWatch?.format('YYYY-MM-DD'),
      finalDate: finalDateWatch?.format('YYYY-MM-DD'),
    });
  const customerWithoutMoviment = flatInfiniteData(data);

  const columns: ColumnsType<CrmCustomerListResponse> = [
    {
      title: 'Nome',
      dataIndex: 'name',
    },
    {
      title: 'Email',
      dataIndex: 'email',
    },
    {
      align: 'right',
      render: (_, row) => (
        <Tooltip title="Ver cliente">
          <button
            onClick={() => {
              history.push(`/app/customers/${row.id}/general`);
              onCancel();
            }}
            style={{
              backgroundColor: 'transparent',
              border: 'none',
            }}
          >
            <Eye style={{ cursor: 'pointer' }} size={16} />
          </button>
        </Tooltip>
      ),
    },
  ];

  return (
    <Modal
      width={600}
      open={open}
      title="Clientes sem movimentação"
      onCancel={onCancel}
      footer={
        <Space>
          <Checkbox
            defaultChecked={!show}
            onChange={({ target: { checked } }) => onChange(!checked)}
          >
            Não exibir ao acessar
          </Checkbox>
          <Button onClick={onCancel}>Fechar</Button>
        </Space>
      }
    >
      <Form form={form}>
        <Row gutter={[16, 16]}>
          <Col span={24} md={12}>
            <FloatingFormItem
              name="initialDate"
              label="Data inicial"
              initialValue={moment().subtract(2, 'months')}
            >
              <InputDate
                allowClear={false}
                disabledDate={(date) =>
                  date.isAfter(finalDateWatch, 'day') ||
                  date.isAfter(moment(), 'day')
                }
              />
            </FloatingFormItem>
          </Col>

          <Col span={24} md={12}>
            <FloatingFormItem
              name="finalDate"
              label="Data final"
              initialValue={moment()}
            >
              <InputDate
                allowClear={false}
                disabledDate={(date) => date.isBefore(moment(), 'day')}
              />
            </FloatingFormItem>
          </Col>
        </Row>
      </Form>
      <InfiniteTable
        dataSource={customerWithoutMoviment}
        columns={columns}
        rowKey={(row) => row.id}
        isFetching={isFetching}
        loading={isLoading}
        hasNextPage={hasNextPage}
        fetchNextPage={fetchNextPage}
      />
    </Modal>
  );
}
